import { supabase } from "@/lib/supabase/supabaseClient";
import { useDeleteSurveyProps } from "./useDeleteSurvey.types";

export const deleteSurvey = async (survey_id: useDeleteSurveyProps) => {
    return await supabase.from('survey').delete().eq('id', survey_id);
}
